import { render } from "./AddDiscount.vue?vue&type=template&id=37a3ed28&ts=true"
import script from "./AddDiscount.vue?vue&type=script&lang=ts"
export * from "./AddDiscount.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__